<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="notifications.length > 0" class="hidden-sm-and-down" color="primary" @mouseup.left="clearNotifDialog = true">{{
                                $t("lang.readAll")
                            }}</v-btn>
                            <bc-btn-refresh @invoke-method="dbGetNotifications()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text>
                    <v-timeline dense clipped v-if="notifications && notifications.length != 0">
                        <v-timeline-item
                            class="mb-3 pa-1"
                            v-for="(notification, index) in notifications"
                            :key="index"
                            :color="notification.icon_class"
                            :icon="notification.icon"
                            icon-color="white"
                            fill-dot
                        >
                            <v-layout
                                class="enlarge notification clickable"
                                @mouseup.left="dbReadNotification(notification, notification.notification_id)"
                                :column="$bp.xs"
                                justify-space-between
                                px-3
                                py-2
                                :style="{
                                    transition: 'all .3s ease-in-out',
                                    'background-color': notification.read_flag == 1 ? '#f5f5f5' : '#e3e3e3',
                                    'border-radius': '10px',
                                    position: 'relative',
                                }"
                            >
                                <div
                                    class="unread-icon"
                                    :style="{ 'background-color': '#00D014', opacity: notification.read_flag == 0 ? 1 : 0, transition: 'all .3s ease-in-out' }"
                                ></div>
                                <v-flex xs12 sm9>
                                    <v-flex :class="{ 'fw-bold': notification.read_flag == 0 }" class="subheading">{{ notification.subject }}</v-flex>
                                    <v-flex mt-2 :class="{ 'fw-bold': notification.read_flag == 0 }" class="subheading">{{ notification.message }}</v-flex>
                                    <v-divider v-if="$bp.xs"></v-divider>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-layout :column="!$bp.xs" :row="$bp.xs">
                                        <v-flex :text-xs-right="!$bp.xs" v-html="notification.date_created"></v-flex>
                                        <v-flex>
                                            <v-layout class="ml-auto notif-icons" row>
                                                <!-- <v-icon :color="notification.read_flag == 1 ? '#969696' : 'primary'" class="mr-1 clickable">delete</v-icon> -->
                                                <v-icon :color="notification.read_flag == 1 ? '#969696' : 'primary'" class="clickable">{{
                                                    notification.read_flag == 1 ? "drafts" : "markunread"
                                                }}</v-icon>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-timeline-item>
                    </v-timeline>
                    <div
                        v-else
                        class="grey--text"
                        style="width: 100%; height: calc(100vh - 250px); display: flex; justify-content: center; align-items: center"
                    >
                        {{ $t("lang.no_notifications") }}
                    </div>
                </v-card-text>
            </v-card>
            <bc-pagination :page="page" :params="axiosParams" path="/notifications"></bc-pagination>
        </v-container>

        <v-dialog v-model="clearNotifDialog" persistent scrollable max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.clearNotifDialog") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="clearNotifDialog"
                        :dialog-status="clearNotifDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex xs12>
                                {{ $t("lang.confirmClearNotif") }}
                            </v-flex>
                            <v-flex xs12 class="fw-bold">
                                {{ $t("lang.notifWarning") }}
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="clearNotifDialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="clearAll()">{{ $t("lang.confirm") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            clearNotifDialog: false,
            mobileList: [
                { title: this.$t("lang.readAll"), action: "control_dialog", dialog_model: "clearNotifDialog", status: true },
                { title: "Refresh", action: "dbGetNotifications" },
            ],
            dbGetNotifications: _.debounce(this.getNotifications, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbReadNotification: _.debounce(this.readNotification, 1500, { maxWait: 1500, leading: true, trailing: false }),
            filter: {
                status: 0,
                has_email: 0,
                people_id: 0,
                page_size: 0,
                page_num: 0,
            },
            page: {},
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchMe", {
                url: "me/notifications",
                method: "get",
                stateProperty: "notifications",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined") {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.notifications_filter);
                        vm.page = data.page;
                        store.commit("setNotificationsHandler", data.notifications);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchMe", {
                url: "me/notifications",
                method: "get",
                stateProperty: "notifications",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined") {
                    this.setQuery(parsedQuery, this.filter, this.notifications_filter);
                    this.page = data.page;
                    this.$store.commit("setNotificationsHandler", data.notifications);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapGetters(["notifications_filter", "notifications"]),
        axiosParams() {
            return this.prepareParams(this.filter, this.notifications_filter);
        },
    },
    methods: {
        getNotifications() {
            this.startLoader();
            this.$store
                .dispatch("fetchMe", {
                    url: "me/notifications",
                    method: "get",
                    stateProperty: "notifications",
                    commit: true,
                })
                .then((data) => {
                    this.finishLoader(true);
                });
        },
        clearAll() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchMe", {
                    url: "me/notifications/read_all",
                    method: "patch",
                })
                .then((data) => {
                    this.$store.commit("readAllNotifsHandler");
                    this.$store.commit("updateNewAlertsHandler", 0);
                })
                .finally(() => {
                    this.$store.commit("toggleModalLoader", false);
                    this.clearNotifDialog = false;
                });
        },
        readNotification(notification, id) {
            let flag = notification.read_flag;
            notification.read_flag = flag == "1" ? "0" : "1";
            // this.$store.commit("updateNewAlertsHandler", this.newAlerts + (flag == "1" ? 1 : -1));
            this.$store.dispatch("fetchMe", {
                url: "me/notifications/" + id + (flag == "1" ? "/unread" : "/read"),
                method: "patch",
            });
        },
    },
};
</script>
